import { useMutation, useQueryClient } from 'react-query';
import {
  actOnBettieProactiveMessage,
  type ActOnBettieProactiveMessageBody,
  type ActOnBettieProactiveMessageResponse
} from '../../services/bettieService';

export function useActOnBettieProactiveMessage() {
  const queryClient = useQueryClient();

  return useMutation<
    ActOnBettieProactiveMessageResponse,
    Error,
    { body: ActOnBettieProactiveMessageBody; chatRoomId: string; proactiveMessageHistoryId: number }
  >(
    ({ body, chatRoomId, proactiveMessageHistoryId }) =>
      actOnBettieProactiveMessage(chatRoomId, proactiveMessageHistoryId, body),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['bettieProactiveMessages', variables.chatRoomId]);
      }
    }
  );
}
